import {Component} from 'san';
import throttle from 'lodash.throttle';
import styles from './style/index.module.less';
import RelateNews from './components/relateNews';
import RecentArticle from './components/recentArticle';
import TopList from './components/topList';

export default class Relate extends Component {
    static template = require('./index.html');
    static components = {
        'ui-relate-news': RelateNews,
        'ui-recent-article': RecentArticle,
        'ui-top-list': TopList,
    };
    static computed = {
        showRecentArticle() {
            const recentArticle = this.data.get('pcRelate.recentArticle');
            return recentArticle.length > 0;
        },
        showRelateNews() {
            const relateNews = this.data.get('pcRelate.relateNews');
            const isBjh = this.data.get('common.isBjh');
            return isBjh && relateNews.length > 0;
        },
        showTopList() {
            const topList = this.data.get('pcRelate.topList');
            return topList.length > 0;
        },
        asyncRecentArticle() {
            const recentArticle = this.data.get('pcRelate.recentArticle');
            return recentArticle;
        },
        asyncRelateNews() {
            const relateNews = this.data.get('pcRelate.relateNews');
            return relateNews;
        },
        asyncTopList() {
            const topList = this.data.get('pcRelate.topList');
            return topList;
        },
        newsNid() {
            const nid = this.data.get('nid');
            return `news_${nid}`;
        },
    }
    initData() {
        return {
            styles,
            isShow: false,
        };
    }
    attached() {
        const scrollFn = throttle(this.scrollHandler.bind(this), 300);
        window.addEventListener('scroll', scrollFn);
    }
    scrollHandler() {
        const hotListScrollTop = this.ref('hotList').offsetTop;
        const height = this.ref('hotList').offsetHeight;
        let totalHeight = hotListScrollTop + height;
        const scrollTop = window.pageYOffset
                        || document.documentElement.scrollTop
                        || document.body.scrollTop
                        || 0;
        if (scrollTop > totalHeight + 150) {
            this.ref('relateNews').style.display = 'block';
            const isShow = this.data.get('isShow');
            if (!isShow) {
                this.data.set('isShow', true);
            }
        } else {
            this.ref('relateNews').style.display = 'none';
        }
    }
}